import { CatmullRomCurve3, Vector3, type QuadraticBezierCurve3 } from 'three'

import type { Direction } from '@config'

export const LEFT_TUBE_SEGMENTS = 8
export const RIGHT_TUBE_SEGMENTS = 8
export const RADIAL_SEGMENTS = 4

export const RAILS_GAUGE = 0.28
export const HALF_RAILS_GAUGE = RAILS_GAUGE / 2
export const RAIL_RADIUS = 0.02
export const RAIL_SCALE_Y = 1.5
export const RAIL_HEIGHT = RAIL_RADIUS * RAIL_SCALE_Y + 0.02

export const DIRECTION_OFFSETS: Record<Direction, Vector3> = {
  N: new Vector3(0, 0, -0.5),
  S: new Vector3(0, 0, 0.5),
  E: new Vector3(0.5, 0, 0),
  W: new Vector3(-0.5, 0, 0),
}

export const CORNER_OFFSETS: Record<Direction, Vector3> = {
  N: new Vector3(1, 0, -1),
  S: new Vector3(-1, 0, 1),
  E: new Vector3(1, 0, 1),
  W: new Vector3(-1, 0, -1),
}

export function buildRailsCurves(curve: QuadraticBezierCurve3, segments = 20) {
  const leftPoints: Vector3[] = []
  const rightPoints: Vector3[] = []

  for (let i = 0; i <= segments; i++) {
    const t = i / segments
    const point = curve.getPointAt(t)
    const tangent = curve.getTangentAt(t).normalize()
    const normal = new Vector3(-tangent.z, 0, tangent.x)
    leftPoints.push(point.clone().addScaledVector(normal, HALF_RAILS_GAUGE))
    rightPoints.push(point.clone().addScaledVector(normal, -HALF_RAILS_GAUGE))
  }

  return {
    leftCurve: new CatmullRomCurve3(leftPoints),
    rightCurve: new CatmullRomCurve3(rightPoints),
  }
}
